const CATS = [
  { key: "todos", label: "Todos", testid: "category-filter-all" },
  { key: "piedra", label: "Pizzas Piedra", testid: "category-filter-piedra" },
  { key: "molde", label: "Pizzas Molde", testid: "category-filter-molde" },
  { key: "xl", label: "Pizzas XL", testid: "category-filter-xl" },
  { key: "empanadas", label: "Empanadas", testid: "category-filter-empanadas" },
  { key: "bebidas", label: "Bebidas", testid: "category-filter-bebidas" },
  { key: "dulces", label: "Dulces", testid: "category-filter-dulces" },
];

const DEFAULT_CAT_ORDER = ["piedra", "molde", "xl", "empanadas", "bebidas", "dulces"];

export default function CategoryTabs({ active, onChange, orden }) {
  const ordenEfec = (orden && orden.length ? orden : DEFAULT_CAT_ORDER);
  const cats = [
    CATS[0],
    ...ordenEfec.map((k) => CATS.find((c) => c.key === k)).filter(Boolean),
    ...CATS.slice(1).filter((c) => !ordenEfec.includes(c.key)),
  ];
  return (
    <div className="sticky top-16 z-30 bg-ink/95 backdrop-blur-lg border-b border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex gap-2 overflow-x-auto thin-scroll py-3 -mx-4 px-4">
          {cats.map((c) => {
            const isActive = active === c.key;
            return (
              <button
                key={c.key}
                data-testid={c.testid}
                onClick={() => onChange(c.key)}
                className={`shrink-0 px-4 py-2 rounded-full text-xs uppercase tracking-widest font-black transition-colors duration-200 border ${
                  isActive
                    ? "bg-brand text-black border-brand"
                    : "bg-transparent text-zinc-300 border-line hover:border-brand hover:text-white"
                }`}
              >
                {c.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
